import { WELCOME_TO_MAPS_VIDEO_URL } from 'constants/map';
import type { FC } from 'react';
import { ReactPlayerProps, default as _ReactPlayer } from 'react-player';
import { ReactComponent as PlayIcon } from '../../../assets/icons/PlayLight.svg';
import videoPoster from '../../../assets/images/common/manage_and_experience_cancer_video_poster.png';
import './video-styles.css';

const ReactPlayer = _ReactPlayer as unknown as React.FC<ReactPlayerProps>;

export const VideoPlayer: FC<ReactPlayerProps> = props => (
    <ReactPlayer
        playing
        data-testid="reactplayer"
        controls
        width="100%"
        height="100%"
        light={videoPoster}
        playIcon={<PlayIcon />}
        url={WELCOME_TO_MAPS_VIDEO_URL}
        style={{ borderRadius: '16px', overflow: 'hidden' }}
        {...props}
    />
);

VideoPlayer.displayName = 'VideoPlayer';
